const meta = {
  module: "clients"
};

export default [
  {
    path: `/clients`,
    redirect: "/clients/page/1"
  },
  {
    path: `/clients/page`,
    redirect: "/clients/page/1"
  },
  {
    path: `/clients/page/:page`,
    name: "clients",
    component: () =>
      import(
        /* webpackChunkName: "clients" */ "@/modules/clients/views/index.vue"
      ),
    meta: {
      ...meta
    }
  },
  {
    path: `/clients/create`,
    name: "clients/create",
    component: () =>
      import(
        /* webpackChunkName: "clients/create" */ "@/modules/clients/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create"
    }
  },
  {
    path: `/clients/edit/:id`,
    name: "clients/edit",
    component: () =>
      import(
        /* webpackChunkName: "clients/edit" */ "@/modules/clients/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit"
    }
  }
];
